import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Row } from '@yme/atoms/grid';
import { ProductType } from '@yme/common/constants';
import { useWindowSize } from '@yme/hooks/index';
import { selectProductCardData } from '@yme/pdp-components/ProductCard';
import { PRODUCT_OVERVIEW_HEADER, PRODUCT_PAGE_HEADING_1, PRODUCT_SHORT_INTRO, } from '@yme/selectors/constants';
import { getAttribute, getProductDetailsData } from '@yme/selectors/products';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { HeadingLevel1 } from '@yme/tokens/typography';
import { BodyTextStyled, SubtitleStyled } from '../styled';
export function HeroInfo() {
    const product = useSelector(getProductDetailsData);
    let productShortIntro = useSelector(getAttribute(PRODUCT_SHORT_INTRO));
    const subTitle = useSelector(getAttribute(PRODUCT_OVERVIEW_HEADER));
    const productCardData = useSelector(selectProductCardData);
    const productPageHeadingLevel1 = useSelector(getAttribute(PRODUCT_PAGE_HEADING_1));
    const isUnit = product?.type === ProductType.UNIT;
    if (isUnit) {
        // B2C-20929 - remove short intro for unit products
        productShortIntro = '';
    }
    const { isMobileView } = useWindowSize();
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { lg: 6, md: 8 },
                React.createElement(SubtitleStyled, { color: colorCoreWhite1000 }, subTitle),
                productCardData?.titleAttribute?.value && (React.createElement(HeadingLevel1, { color: colorCoreWhite1000 }, productPageHeadingLevel1 || productCardData.titleAttribute.value)))),
        !isMobileView && (React.createElement(Row, null,
            React.createElement(Col, { lg: 6, md: 8 },
                React.createElement(BodyTextStyled, null, productShortIntro))))));
}
HeroInfo.displayName = 'HeroInfo_Component';
